export enum DevicePermission {
  CAMERA = 'camera',
  MICROPHONE = 'microphone',
}
